import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";

interface IThemeForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const ThemeForm: React.FC<IThemeForm> = ({ loading, form, submit }) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="Code"
          className="w-full"
          {...form.register("code", { required: "Code requis" })}
          placeholder="modern-dark"
        />
        <Input
          label="Nom"
          className="w-full"
          {...form.register("name", { required: "Nom requis" })}
          placeholder="Moderne sombre"
        />
        <Textarea
          label="Prompt"
          className="w-full"
          rows={8}
          {...form.register("promptText", { required: "Prompt requis" })}
          placeholder="Décris le style, la structure et l'ambiance générale du thème..."
        />
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
